// https://vuex.vuejs.org/en/state.html

export default {
    packageVersion: process.env.VUE_APP_VERSION || '0',
    drawer: null
}